
	import Vue from 'vue'

  export default Vue.extend({
    name: 'Unauthorized',
    data: () => ({
    }),
    methods: {
    },
    computed: {
    }
  })
